import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const customTabInit = (tabId, allMarginList) => ({
    type: actionTypes.CUSTOM_TAB_INIT,
    payload: {
        tabId: tabId,
        allMarginList: allMarginList
    }
});

export const selectProduct = (tabId, product) => ({
    type: actionTypes.CUSTOM_TAB_SELECT_PRODUCT,
    payload: {
        tabId: tabId,
        product: product
    }
});

export const addCustomFandeck = (fandeckName) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_CUSTOM_FANDECK,
        params: {
            name: fandeckName
        }
    },
    method: handlers.ADD_CUSTOM_FANDECK,
    tabId: 0
});

export const createNewFandeckAndAddCustomFormula = (tabId, name) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_CUSTOM_FANDECK,
        params: {
            name: name
        }
    },
    method: handlers.ADD_CUSTOM_FANDECK_AND_ADD_CUSTOM_FORMULA,
    tabId: tabId
});

export const editCustomFandeck = (id, name) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_EDIT_CUSTOM_FANDECK,
        params: {
            id: id,
            name: name
        }
    },
    method: handlers.EDIT_CUSTOM_FANDECK,
    tabId: 0
});

export const removeCustomFandeck = (fandeck) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_REMOVE_CUSTOM_FANDECK,
        params: {
            id: fandeck.id
        }
    },
    method: handlers.REMOVE_CUSTOM_FANDECK,
    tabId: 0
});

export const selectCustomFandeck = (tabId, fandeck) => ({
    type: actionTypes.CUSTOM_TAB_SELECT_FANDECK,
    payload: {
        tabId: tabId,
        fandeck: fandeck
    }
});

export const selectPackage = (tabId, selectedPackage) => ({
    type: actionTypes.CUSTOM_TAB_SET_PACKAGE,
    payload: {
        tabId: tabId,
        selectedPackage: selectedPackage
    }
});

export const selectBase = (tabId, product, base) => ({
    type: actionTypes.CUSTOM_TAB_SELECT_BASE,
    payload: {
        tabId: tabId,
        product: product,
        base: base
    }
});

export const changeFormulaName = (tabId, name) => ({
    type: actionTypes.CUSTOM_TAB_CHANGE_FORMULA_NAME,
    payload: {
        tabId: tabId,
        name: name
    }
});

export const changeFormulaCode = (tabId, code) => ({
    type: actionTypes.CUSTOM_TAB_CHANGE_FORMULA_CODE,
    payload: {
        tabId: tabId,
        code: code
    }
});

export const setMoreInfoText = (tabId, moreInfoText) => ({
    type: actionTypes.CUSTOM_TAB_SET_MORE_INFO_TEXT,
    payload: {
        tabId: tabId,
        moreInfoText: moreInfoText
    }
});

export const editFormulaRgb = (tabId, rgb) => ({
    type: actionTypes.FORMULA_TAB_EDIT_FORMULA_RGB,
    payload: {
        tabId: tabId,
        rgb: rgb
    }
});

export const checkAndAddCustomFormula = (
    tabId,
    product,
    fandeck,
    color,
    base,
    searchPanelColorCode,
    searchPanelBase
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_CHECK_CUSTOM_FORMULA,
        params: {
            productId: product.id,
            fandeckId: fandeck.id,
            colorName: color.name.trim(),
            colorCode: searchPanelColorCode && color.code !== null ? color.code.trim() : null,
            baseId: searchPanelBase ? (base === null ? null : base.id) : null
        }
    },
    method: handlers.CHECK_AND_ADD_CUSTOM_FORMULA,
    tabId: tabId
});

export const checkCustomCifAndAddCustomFormula = (tabId, fandeck, color, reflData, searchPanelColorCode) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_CHECK_CUSTOM_CIF,
        params: {
            fandeckId: fandeck.id,
            colorName: color.name.trim(),
            colorCode: searchPanelColorCode && color.code !== null ? color.code.trim() : null,
            rgb: color.rgb,
            reflData: reflData
        }
    },
    method: handlers.CHECK_CUSTOM_CIF_AND_ADD_CUSTOM_FORMULA,
    tabId: tabId
});

export const addCustomFormula = (tabId) => ({
    type: actionTypes.CUSTOM_TAB_ADD_CUSTOM_FORMULA,
    payload: {
        tabId: tabId
    }
});

export const removeSelectedCustomProduct = (tabId) => ({
    type: actionTypes.CUSTOM_TAB_REMOVE_SELECTED_PRODUCT,
    payload: {
        tabId: tabId
    }
});

export const removeSelectedCustomFandeck = (tabId) => ({
    type: actionTypes.CUSTOM_TAB_REMOVE_SELECTED_FANDECK,
    payload: {
        tabId: tabId
    }
});

export const removeSelectedCustomBase = (tabId) => ({
    type: actionTypes.CUSTOM_TAB_REMOVE_SELECTED_BASE,
    payload: {
        tabId: tabId
    }
});

export const getAllCustomFandecks = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_CUSTOM_FANDECKS
    },
    method: handlers.GET_ALL_CUSTOM_FANDECKS,
    tabId: 0
});

export const setMasterProduct = (tabId, masterProduct) => ({
    type: actionTypes.CUSTOM_TAB_SET_MASTER_PRODUCT,
    payload: {
        tabId: tabId,
        masterProduct: masterProduct
    }
});

export const getPackagesByParams = (tabId, productId, baseId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_PACKAGES_BY_PARAMS,
        params: {
            productId: productId,
            baseId: baseId
        }
    },
    method: handlers.CUSTOM_TAB_GET_PACKAGES_BY_PARAMS,
    tabId: tabId
});
